import Vue from "vue";
import VueGtag from "vue-gtag";
import router from "../router";

Vue.use(
  VueGtag,
  {
    config: { id: "UA-165063170-2" },
    bootstrap: false
  },
  router
);
